const teamColours: { [key: string]: string } = {
    "Atlanta Hawks": "#E03A3E", // Red
    "Boston Celtics": "#007A33", // Green
    "Brooklyn Nets": "#000000", // Black
    "Charlotte Hornets": "#1D1160", // Purple
    "Chicago Bulls": "#CE1141", // Red
    "Cleveland Cavaliers": "#6F263D", // Wine
    "Dallas Mavericks": "#00538C", // Blue
    "Denver Nuggets": "#0E2240", // Navy
    "Detroit Pistons": "#C8102E", // Red
    "Golden State Warriors": "#1D428A", // Royal Blue
    "Houston Rockets": "#CE1141", // Red
    "Indiana Pacers": "#002D62", // Navy
    "Los Angeles Clippers": "#C8102E", // Red
    "Los Angeles Lakers": "#552583", // Purple
    "Memphis Grizzlies": "#5D76A9", // Navy Blue
    "Miami Heat": "#98002E", // Red
    "Milwaukee Bucks": "#00471B", // Green
    "Minnesota Timberwolves": "#0C2340", // Navy
    "New Orleans Pelicans": "#0C2340", // Navy
    "New York Knicks": "#F58426", // Orange
    "Oklahoma City Thunder": "#007AC1", // Blue
    "Orlando Magic": "#0077C0", // Blue
    "Philadelphia 76ers": "#006BB6", // Blue
    "Phoenix Suns": "#1D1160", // Purple
    "Portland Trail Blazers": "#E03A3E", // Red
    "Sacramento Kings": "#5A2D81", // Purple
    "San Antonio Spurs": "#C4CED4", // Silver
    "Toronto Raptors": "#CE1141", // Red
    "Utah Jazz": "#002B5C", // Navy
    "Washington Wizards": "#002B5C", // Navy
  };
  
  export default teamColours;
  